import { GRAPH_ANALYTICS_ACTION_TYPES } from '../../actions/reports/graph_analytics_action';

const initialState = {
    filters: {
        startDate: new Date((new Date()).setMonth((new Date()).getMonth() - 1)),
        endDate: new Date(),
        worker: null,
        customer: null,
        subArea: null,
        article: null
    },
    customersDailyCount: {},
    customersMonthlyCountByWorkers: [],
    appointmentsMonthlyCountByWorkers: [],
    appointmentsCountByCustomers: []
};

export const graphAnalytics = (state = initialState, action) => {
    switch (action.type) {
        case GRAPH_ANALYTICS_ACTION_TYPES.CHANGE_FILTERS:
            return { ...state, filters: action.payload };
        case GRAPH_ANALYTICS_ACTION_TYPES.GET_CUSTOMERS_DAILY_COUNT:
            return { ...state, customersDailyCount: action.payload };
        case GRAPH_ANALYTICS_ACTION_TYPES.GET_CUSTOMERS_MONTLY_COUNT_BY_WORKERS:
            return { ...state, customersMonthlyCountByWorkers: action.payload };
        case GRAPH_ANALYTICS_ACTION_TYPES.GET_APPOINTMENTS_MONTLY_COUNT_BY_WORKERS:
            return { ...state, appointmentsMonthlyCountByWorkers: action.payload };
        case GRAPH_ANALYTICS_ACTION_TYPES.GET_APPOINTMENTS_COUNT_BY_CUSTOMERS:
            return { ...state, appointmentsCountByCustomers: action.payload };
        default:
            return state;
    }
}
